import React from "react";

const RecipeToggle = ({
  id,
  checked,
  onChange,
  label,
  className = "",
  children,
}) => (
  <label
    className={`recipe-toggle-control ${className}`.trim()}
    htmlFor={id}
  >
    <input
      id={id}
      className="recipe-toggle-input"
      type="checkbox"
      checked={checked}
      aria-label={label}
      onChange={(event) => onChange(event.currentTarget.checked)}
    />
    <span className="recipe-toggle-track" aria-hidden="true">
      <span className="recipe-toggle-thumb" />
    </span>
    {children}
  </label>
);

export default RecipeToggle;
